import { TFunction } from 'next-i18next';

export const getFeedBackRules = (t: TFunction) => ({
  question: [{ required: true, message: t('common:validation.required', { name: 'question' }) }],
  name: [{ required: true, message: t('common:validation.required', { name: 'name' }) }],
  email: [
    { required: true, message: t('common:validation.required', { name: 'email address' }) },
    { type: 'email', message: t('common:validation.email') },
  ],
  text: [{ required: true, message: t('common:validation.required', { name: 'text' }) }],
});
